import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import LoginModal from '../../components/feature/LoginModal';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import ScenariosSection from './components/ScenariosSection';
import HowItWorksSection from './components/HowItWorksSection';
import ComplianceSection from './components/ComplianceSection';
import CTASection from './components/CTASection';

export default function HomePage() {
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Navbar onLoginClick={() => setIsLoginModalOpen(true)} />
      <HeroSection />
      <ServicesSection />
      <ScenariosSection />
      <HowItWorksSection />
      <ComplianceSection />
      <CTASection />
      <Footer />
      <LoginModal isOpen={isLoginModalOpen} onClose={() => setIsLoginModalOpen(false)} />
    </div>
  );
}
